import React from 'react';

export const QuestionnaireAdminTypeTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-4 mb-6" data-testid="questionnaire-admin-tabs-wrapper">
      <div className="flex items-center gap-4">
        <button
          onClick={() => setActiveTab('casas')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition ${
            activeTab === 'casas' ? 'bg-green-100 text-green-700 border-b-2 border-green-500' : 'text-gray-500 hover:text-gray-700'
          }`}
          data-testid="questionnaire-admin-tab-casas"
        >
          <span>🏠</span> Questionário de Casas
        </button>
        <button
          onClick={() => setActiveTab('carros')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition ${
            activeTab === 'carros' ? 'bg-red-100 text-red-700 border-b-2 border-red-500' : 'text-gray-500 hover:text-gray-700'
          }`}
          data-testid="questionnaire-admin-tab-carros"
        >
          <span>🚗</span> Questionário de Carros
        </button>
      </div>
    </div>
  );
};
